import React, { useState,useEffect, useCallback } from 'react';
import {
    required, minLength, maxLength, minValue, maxValue,
    number, regex, email, choices,
    TabbedForm, FormTab, DeleteButton, useRefresh, AutocompleteInput,
    Edit, SimpleForm, TextInput, RichTextField,
    ReferenceInput, SelectInput, EditButton, NumberField,
    DateInput, BooleanInput, NumberInput, ImageInput, ImageField,
    ReferenceManyField, ReferenceField, Datagrid, TextField, BooleanField, FormDataConsumer
} from 'react-admin';
import { useForm } from 'react-final-form';
import { containerStyles } from "../../../common/formStyles";
import * as apiClient from "../../../common/apiClient";
import { toast } from 'react-toastify';


export const AllotmentFields = ({ calimOrdId, formData, ...rest }) => {
    const form = useForm();
    const classes = containerStyles({});
    const [isFoPayAllowed, setIsFoPayAllowed] = useState(false);
    const [fetchedFOClaimFeeAmt, setFetchedFOClaimFeeAmt] = useState(0);
    const [isFoPayAllowedSaved, setIsFoPayAllowedSaved] = useState(false);
    const [isPaymentPaidSaved, setIsPaymentPaidSaved] = useState(false);
    
    useEffect(() => {if (calimOrdId) {getClaimAmount();}}, [calimOrdId]); 
    useEffect(() => {
        setIsFoPayAllowedSaved(formData.isFoPaymentRaised) 
        
        setIsPaymentPaidSaved( formData.paymentPaid);

    }, []); 
    
    const getClaimAmount = () => { 
        
        apiClient.GetClaimAmount(formData.id).then(res => { 
            
            if (res.length > 0) {
               const claimAmt = res[0].claimAmt || 0;
               form.change("foClaimFeeAmount", claimAmt);
                setFetchedFOClaimFeeAmt(claimAmt); 
                setIsFoPayAllowed(true);
            } else {
                setIsFoPayAllowed(false); // no data case
            }
        }).catch(err => {
            console.log(err, "======err GetClaimAmount=======");
        });
    }
   

    const calculateTotal = (foClaimFeeAmount, foIncentiveAmount, foOtherAmount, fotaAmount) => {
        
        
        foClaimFeeAmount = isNaN(parseFloat(foClaimFeeAmount)) ? 0 : parseFloat(foClaimFeeAmount); 
        foIncentiveAmount = isNaN(parseFloat(foIncentiveAmount)) ? 0 : parseFloat(foIncentiveAmount);
        foOtherAmount = isNaN(parseFloat(foOtherAmount)) ? 0 : parseFloat(foOtherAmount);
        fotaAmount = isNaN(parseFloat(fotaAmount)) ? 0 : parseFloat(fotaAmount);
        form.change("foTotalAmount", foClaimFeeAmount + foIncentiveAmount + foOtherAmount + fotaAmount );
        console.log("FO Tot Amt.:",  foClaimFeeAmount + foIncentiveAmount + foOtherAmount + fotaAmount);

    }

    return (
    <div className="alotment-field-parent" style={{ display: "flex", gap: "24px", alignItems: "flex-start" }}>
        
        {/* LEFT SIDE - Amount Fields */}
        <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
            <BooleanInput
                variant="outlined"
                source="isFoPaymentRaised"
                label="FO Payment Raised"
                disabled={isFoPayAllowedSaved}
                onChange={(e) => {
                    if (!isFoPayAllowed && (e)) {
                        toast.error("Please close the status and then raise FO Payment");
                        form.change("isFoPaymentRaised", false);
                        // form.change("foClaimFeeAmount", 0);
                        return;
                    }
                     calculateTotal(fetchedFOClaimFeeAmt, formData.foIncentiveAmount, formData.isPaidByFOOtherAmount?formData.foOtherAmount:0, formData.fotaAmount);
                    form.change("foPaymentRaisedDate", new Date());
                    console.log("FO Fee Amt.:", formData.foClaimFeeAmount);
                }}
                fullWidth={true} className="fo-payment-raised" />

            <DateInput variant="outlined" label="Fo Payment Raised Date" source="foPaymentRaisedDate" fullWidth={true} formClassName={classes.first_inline_input}
                disabled={isFoPayAllowedSaved} />

            <NumberInput disabled
                variant="outlined" source="foClaimFeeAmount" label="Claim Fee Amount" fullWidth={true} formClassName={classes.last_inline_input} />

            <NumberInput
                onChange={(e) => { calculateTotal(formData.foClaimFeeAmount, formData.isPaidByFOOtherAmount?formData.foOtherAmount:0, formData.fotaAmount); }}
                variant="outlined" source="foIncentiveAmount" fullWidth={true} label="Incentive Amount" formClassName={classes.first_inline_input}
                disabled={isFoPayAllowedSaved} />

            <NumberInput
                onChange={(e) => { calculateTotal(formData.foClaimFeeAmount, formData.foIncentiveAmount, formData.isPaidByFOOtherAmount? e.target.value:0, formData.fotaAmount); }}
                variant="outlined" source="foOtherAmount" fullWidth={true} label="ICP/Document Charges" formClassName={classes.last_inline_input}
                disabled={isFoPayAllowedSaved} />

            <NumberInput
                onChange={(e) => { calculateTotal( formData.foClaimFeeAmount, formData.foIncentiveAmount,formData.isPaidByFOOtherAmount? formData.foOtherAmount:0, e.target.value); }}
                variant="outlined" source="fotaAmount" fullWidth={true} label="TA Amount" formClassName={classes.first_inline_input}
                disabled={isFoPayAllowedSaved} />

            <NumberInput disabled variant="outlined" source="foTotalAmount" fullWidth={true} label="Total Amount" formClassName={classes.last_inline_input} />
        </div>

        {/* RIGHT SIDE - Payment Fields */}
        <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
            <NumberInput variant="outlined" source="foTotalPaidAmount" fullWidth={true} label="Total Paid Amount" formClassName={classes.first_inline_input} disabled={true} />

            <TextInput variant="outlined" source="paymentMode" fullWidth={true} label="Payment Mode" formClassName={classes.last_inline_input} disabled={true} />

            <BooleanInput variant="outlined" source="paymentPaid"
                disabled={true}
                onChange={(e) => {
                    if (e) {
                        if (!isFoPayAllowed) {
                            toast.error("Please close the status and then raise FO Payment");
                            form.change("paymentPaid", false);
                            return;
                        }
                        form.change("foPaymentDate", new Date());
                    } else {
                        form.change("foPaymentDate", null);
                    }
                }}
                fullWidth={true} label="Payment Paid" formClassName={classes.first_inline_input} />

            <DateInput variant="outlined" source="foPaymentDate" fullWidth={true} label="Payment Paid Date" formClassName={classes.last_inline_input} disabled={true} />

            <TextInput variant="outlined" label="Fo Payment Neft Det" source="foPaymentNeftDet" fullWidth={true} formClassName={classes.last_three_input} disabled={true} />

            <TextInput variant="outlined" source="paymentRemarks" label="Payment Remarks" className="fo-payment-remarks" disabled={true} />
            <BooleanInput variant="outlined" source="isPaidByFOOtherAmount" fullWidth={true} label="Is Paid by FO ICP/Document Charges" formClassName={classes.first_inline_input}
             onChange={(e) => {
                calculateTotal( formData.foClaimFeeAmount, formData.foIncentiveAmount, 0, formData.fotaAmount);
                    
                }}
            />
        </div>

    </div>
)
}
